import request from '@/utils/request'

const prefix = '/django_rest/client-admin/school-management'

export default {
  getSchoolManagementList (params) {
    return request.get(`${prefix}/`, { params })
  },
  createSchool (params) {
    return request.post(`${prefix}/`, params)
  },
  updateSchool (params) {
    return request.put(`${prefix}/`, params)
  }
}
